<template>
  <v-container>
     <div class="display-2 mb-7 mt-5 font-weight-thin" color="primary">{{$tc('entities.jobStage.title',2)}}</div>

    <alert-box v-model="alert.alerts" :type="alert.type" @close="alert.alerts = []"></alert-box>
    <btn-a rounded color="primary" @click="editItem" :access="$access.jobStage.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
       @input="pagination.page = $event"
    />

    <dialog-d
      ref="dialogEdit"
      title="Job Stage"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.jobStage.edit"
      :accessDelete="$access.jobStage.delete"
      :alert="form.alert"
    >
      <jobStageForm ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import jobStageForm from "../components/forms/jobStages/jobStageForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";

export default {
  mixins: [pageListMixing],
  components: { jobStageForm },

  data() {
    return {
      apiController: "jobstage",
      idParamName: "jobId",
      getAllByIdParam: true,
      headers: [
        {
          text: this.$t('entities.jobStage.props.description') ,
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: this.$t('entities.jobStage.props.status'),
          align: "left",
          sortable: false,
          value: "status"
        },

        { text: this.$t("table.actions"), value: "action", sortable: false, align: "right" }
      ],
      actions: [
        {
         text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.jobStage.edit, this.$access.jobStage.show]
        },

        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.jobStage.delete
        }
      ]
    };
  },
  methods: {
    clickItemSelect(row) {
      this.$parent.$emit("clickTeste", row);
      // this.testeItems = [row];
      // this.teste = row;
      //this.$refs.dialogSelect.open();
    },
    clickSelect() {
      this.$refs.dialogSelect.open();
    },
    async getModelDefault() {
      return {
        description: "",
        stages: [],
        jobStageItemProds: [],
        jobStageItemConss: [],
        jobId: this.$route.params.jobId
      };
    }
  },
  async mounted() {
    await this.getItems();
  }
};
</script>